import template from './Setup.svelte'
import { getTabTool } from '@fno/service/api/tasks.js'

const resolve = async (ignore, { schoolId }) => {
    const task = await getTabTool({ schoolId })
    if (task) {
        return Promise.reject({
            redirectTo: {
                name: 'hello.task',
                params: { schoolId }
            }
        })
    }
    return {}
}

export default (parent, stateRouter) => {
    const name = `${parent}.setup`

    stateRouter.addState({
        name,
        route: '/setup',
        template,
        resolve
    })
}
